import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiDropdownMobile, tuiProvideMobileCalendar } from '@taiga-ui/addon-mobile';
import { TuiTable } from '@taiga-ui/addon-table';
import {
  TuiActiveZone,
  TuiAutoFocus,
  TuiElement,
  TuiHovered,
  TuiItem,
  TuiObscured,
  TuiResizable,
  TuiResizer,
  TuiValueChanges,
} from '@taiga-ui/cdk';
import {
  TuiAppearance,
  TuiButton,
  tuiButtonOptionsProvider,
  TuiCalendar,
  TuiDataList,
  TuiDropdown,
  TuiError,
  TuiFlagPipe,
  TuiGroup,
  TuiHint,
  TuiHintOverflow,
  tuiHintOptionsProvider,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiLoader,
  TuiNotification,
  TuiNumberFormat,
  TuiRoot,
  TuiScrollable,
  TuiScrollbar,
  TuiTextfieldComponent,
  TuiTextfieldDirective,
  TuiTextfieldDropdownDirective,
  TuiTextfieldMultiComponent,
  TuiTextfieldOptionsDirective,
  tuiTextfieldOptionsProvider,
  TuiTitle,
} from '@taiga-ui/core';
import { provideEventPlugins } from '@taiga-ui/event-plugins';
import { TuiExpand } from '@taiga-ui/experimental/components/expand';
import {
  TuiAccordion,
  TuiAvatar,
  TuiBadge,
  TuiBadgedContent,
  TuiBadgeNotification,
  TuiBlock,
  TuiBreadcrumbs,
  TuiButtonLoading,
  TuiCheckbox,
  tuiCheckboxOptionsProvider,
  TuiChevron,
  TuiChip,
  TuiComboBox,
  TuiDataListDropdownManager,
  TuiDataListWrapper,
  TuiFiles,
  TuiFilterByInputPipe,
  TuiInputDate,
  TuiInputDateTime,
  TuiInputInline,
  TuiInputNumber,
  TuiInputSlider,
  TuiInputTime,
  TuiLineClamp,
  TuiMultiSelect,
  TuiPassword,
  TuiProgress,
  TuiPush,
  TuiRadio,
  TuiRadioList,
  TuiSegmented,
  TuiSelect,
  TuiSkeleton,
  TuiStringifyContentPipe,
  TuiSwitch,
  tuiSwitchOptionsProvider,
  TuiTabs,
  TuiTextarea,
  TuiTextareaLimit,
  tuiTextareaOptionsProvider,
  TuiTooltip,
} from '@taiga-ui/kit';
import { TuiForm } from '@taiga-ui/layout';
import { PolymorpheusOutlet } from '@taiga-ui/polymorpheus';

const ALL_TAIGA_UI_MODULES = [
  FormsModule,
  ReactiveFormsModule,
  ScrollingModule,
  PolymorpheusOutlet,
  /* CDK */
  TuiActiveZone,
  TuiAutoFocus,
  TuiElement,
  TuiHovered,
  TuiItem,
  TuiObscured,
  TuiResizable,
  TuiResizer,
  TuiValueChanges,
  /* CORE */
  TuiAppearance,
  TuiButton,
  TuiCalendar,
  TuiDataList,
  TuiDropdown,
  TuiError,
  TuiFlagPipe,
  TuiGroup,
  TuiHint,
  TuiHintOverflow,
  TuiLabel,
  TuiLink,
  TuiLoader,
  TuiNotification,
  TuiNumberFormat,
  TuiRoot,
  TuiScrollbar,
  TuiScrollable,
  TuiIcon,
  TuiTextfieldComponent,
  TuiTextfieldMultiComponent,
  TuiTextfieldDirective,
  TuiTextfieldDropdownDirective,
  TuiTextfieldOptionsDirective,
  /* EXPERIMENTAL */
  TuiExpand,
  /* KIT */
  TuiAccordion,
  TuiAvatar,
  TuiBadge,
  TuiBadgedContent,
  TuiBadgeNotification,
  TuiBreadcrumbs,
  TuiButtonLoading,
  TuiBlock,
  TuiCheckbox,
  TuiChevron,
  TuiComboBox,
  TuiMultiSelect,
  TuiDataListDropdownManager,
  TuiDataListWrapper,
  TuiFiles,
  TuiFilterByInputPipe,
  TuiInputInline,
  TuiInputDate,
  TuiInputDateTime,
  TuiInputNumber,
  TuiPassword,
  TuiInputSlider,
  TuiInputTime,
  TuiLineClamp,
  TuiProgress,
  TuiPush,
  ...TuiRadio,
  TuiRadioList,
  TuiSegmented,
  TuiSelect,
  TuiSkeleton,
  TuiStringifyContentPipe,
  TuiTabs,
  TuiTextarea,
  TuiTextareaLimit,
  TuiTooltip,
  TuiSwitch,
  TuiTitle,
  /* ADDON-MOBILE */
  TuiDropdownMobile,
  /* ADDON-TABLE */
  TuiTable,
  TuiChip,
  /*layout*/
  TuiForm,
];

@NgModule({
  imports: [ALL_TAIGA_UI_MODULES],
  exports: [ALL_TAIGA_UI_MODULES],
  providers: [
    provideEventPlugins(),
    tuiProvideMobileCalendar(),
    tuiCheckboxOptionsProvider({ size: 's' }),
    tuiSwitchOptionsProvider({ size: 's' }),
    tuiHintOptionsProvider({ appearance: 'custom' }),
    tuiButtonOptionsProvider({ size: 'm' }),
    tuiTextfieldOptionsProvider({ size: signal('m') }),
    tuiTextareaOptionsProvider({ max: 6 }),
  ],
})
export class TaigaModule {}
